import type { AvailableFilters } from "@/features/eventSearch/hooks/useEventsFilters"
import type { GetEventsResponse } from "@/modules/events/api/getEvents"
import type { FunctionComponent } from "react"

import dynamic from "next/dynamic"
import { useSearchParams } from "next/navigation"
import { useState } from "react"

import { Filter } from "@jobteaser/spark/components/Icons/Filter"

import { useEventsFilters } from "@/features/eventSearch/hooks/useEventsFilters"
import { FilterButton } from "@/modules/landingSearch/components/FilterButton/FilterButton"

import styles from "@/modules/landingSearch/components/Filters/Filters.module.css"

const DynamicTranslationProvider = dynamic(() =>
  import("@/modules/i18n/components/TranslationProvider").then(component => component.TranslationProvider)
)
const DynamicSecondaryFiltersModal = dynamic(() =>
  import("./SecondaryFiltersModal").then(mod => mod.SecondaryFiltersModal)
)

type SecondaryFiltersProps = {
  filters: GetEventsResponse["meta"]["filters"]
  triggerButtonlabel: string
}

const secondaryFilters: (keyof AvailableFilters)[] = ["locations", "sectors", "functions"]

export const SecondaryFilters: FunctionComponent<SecondaryFiltersProps> = ({ filters, triggerButtonlabel }) => {
  const { navigateWithUpdatedQueryParams } = useEventsFilters()
  const [isModalDisplayed, displayModal] = useState(false)
  const searchParams = useSearchParams()

  const handleCloseModal = (): void => displayModal(false)
  const handleOpenModal = (): void => displayModal(true)
  const handleApply = (updatedFilters: AvailableFilters): void => {
    navigateWithUpdatedQueryParams(updatedFilters)
    displayModal(false)
  }
  const activeFiltersCount = secondaryFilters.reduce(
    (subTotal, filterName) => subTotal + searchParams.getAll(filterName).length,
    0
  )
  const isButtonFilled = activeFiltersCount > 0

  return (
    <>
      <FilterButton
        className={styles.allFiltersButton}
        counter={isButtonFilled ? activeFiltersCount : null}
        data-testid="job-ads-secondary-filters-modal-open-button"
        icon={Filter}
        isActive={isButtonFilled}
        onClick={handleOpenModal}
      >
        {triggerButtonlabel}
      </FilterButton>
      {isModalDisplayed && (
        <DynamicTranslationProvider>
          <DynamicSecondaryFiltersModal filters={filters} onApply={handleApply} onClose={handleCloseModal} />
        </DynamicTranslationProvider>
      )}
    </>
  )
}
